import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/package_deliver_write_off_index/:Record?",
  component: function component() {
    return import("../../../views/package_deliver_write_off/package_deliver_write_off_index.vue");
  },
  name: "package_deliver_write_off_index",
  meta: {
    title: "酒券批量核销",
    foot: true
  }
}, {
  path: "/package_deliver_write_off_add",
  component: function component() {
    return import("../../../views/package_deliver_write_off/package_deliver_write_off_add.vue");
  },
  name: "package_deliver_write_off_add",
  meta: {
    title: "机主扫码核销",
    foot: true
  }
}];